import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { UtilitiesService } from '../services/utilities.service';
import { UtilityServiceSearchModel } from 'app/signup/models/signup-service.model';

@Injectable()
export class UtilityServicesSearchResolver  {

    constructor(private utilities_service: UtilitiesService)
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<Array<UtilityServiceSearchModel>> {
        return this.utilities_service.GetUtilityServicesSearch();
  }
}
